import {BaseView} from '../core/view';
import constants from './constants';
import { ApiUtil } from '../utils/api-util';
import { LinkUtil } from '../utils/link';
import {JSErrorTracking} from '../utils/js-error-tracking';

export default BaseView.extend({

    el: '.js-sort-tab',
    urlParams: undefined,
    initialActiveSort: [],
    activeSort: [],
    firstLoad: true,
    applyIsActive: false,
    sortData: [],


    templates: {
        LIST_FILTER_TEMPLATE: require("./templates/mobile-sort-list-template.hbs"),
    },

    events: {
        'click .js-select-sort' : 'onSortClick',
        'click .js-sort-apply' : 'onSortApply',
        'click .js-sort-clear' : 'onSortClear',
    },

    initialize: function() {
        var self = this;
        this.urlParams = $('#searchfeed').data('active-querystring');
        this.initializeSortByData();

    },

    onSortClick: function(e){
        e.preventDefault();
        var self = this;
        self.sortData = _.map(self.sortData,function(itm){
            if (itm.name == self.$el.find(e.currentTarget).data('name')){
                itm.active = true;
                self.activeSort = itm;
            }else {
                itm.active = false;
            }
            return itm;
        });

        this.fillList();
        this.manageActiveFiltersStatus();
    },

    manageActiveFiltersStatus: function(){
        if (_.isMatch(this.initialActiveSort, this.activeSort)){
            this.applyIsActive = false;
            $('.js-sort-apply').addClass('button--inactive').removeClass('button--teal').addClass('button--grey-light');
        }else{
            this.applyIsActive = true;
            $('.js-sort-apply').removeClass('button--inactive').removeClass('button--grey-light').addClass('button--teal');
        }


    },

    onSortClear: function(){
        var self = this;
        self.sortData = _.map(self.sortData,function(itm){
            if (itm.name == self.initialActiveSort.name){
                itm.active = true;
                self.activeSort = itm;
            }else {
                itm.active = false;
            }
            return itm;
        });
        this.fillList();
        this.manageActiveFiltersStatus();
    },

    onSortApply: function(){
        if (this.applyIsActive){
            LinkUtil.goToUrl(this.activeSort.url);
        }
    },

    clearFilters: function(e){
        e.preventDefault();
        for (var filterType in this.listFilterViews) {
            this.listFilterViews[filterType].clearFilter();
        }
        this.activeFilters = [];
        this.manageActiveFiltersStatus();
    },

    fillList: function(){
        var self = this;
        var code = "";

        $.each(this.sortData, function(i, val) {

            var data = {
                name: val.name,
                url: val.url,
                active: val.active,
                firstActive : false,
            }

            if ((data.active==true)&&(self.firstLoad)){
                self.initialActiveSort = data;
            }
            if (data.name == self.initialActiveSort.name){
                data.firstActive = true;
            }

            code += self.templates.LIST_FILTER_TEMPLATE(data);

        });


        self.$el.find(".js-sort-list").html(code);
        self.$el.addClass('tab-view__content--loaded');
        this.firstLoad = false;
    },

    initializeSortByData: _.once(function() {
        var self = this;
        ApiUtil.request({
            path: constants.GET_SORT_BY_LIST_API_URL + encodeURIComponent(self.urlParams),
            success: function(data) {
                if (data.length>0){
                    JSErrorTracking.sendCustomError("Sort API Error - Data is empty");
                }
                self.sortData = data.options;
                self.fillList();

            },
            error: function(xhr, error){
                JSErrorTracking.sendCustomError("Filter API Error - URL not found - status:"+xhr.status);
            }
        });

    })



});